/**
 * Preparativi comuni dei tutorial delle liste del Sito Ecommerce: aprire e richiudere
 * il menu a tre puntini della prima riga.
 *
 * Il bersaglio dell'attivatore e' scoped alla pagina; le voci del menu no, perche'
 * Vuetify stacca il contenuto dei menu e lo appende a `[data-app]`, fuori dalla pagina.
 */
function isVisible(selector) {
	const element = document.querySelector(selector);

	if (!element || element.getClientRects().length === 0) {
		return false;
	}

	// un menu in chiusura resta a schermo per l'animazione, ma perde subito la classe attiva
	const content = element.closest('.v-menu__content');

	return !content || content.classList.contains('menuable__content__active');
}

// lascia scattare la chiusura che Vuetify ha gia' in coda (il click su "Avanti" e' un click fuori)
function afterPendingClose() {
	return new Promise(resolve => setTimeout(resolve, 0));
}

async function waitFor(probe, wanted, timeout = 1500) {
	const deadline = performance.now() + timeout;

	while (performance.now() < deadline) {
		if (isVisible(probe) === wanted) {
			return;
		}

		await new Promise(resolve => setTimeout(resolve, 50));
	}
}

/**
 * @param {string} scope valore di `data-tour-scope` della pagina
 * @param {string} probe selettore di una voce del menu, per sapere se e' aperto
 */
export function rowMenuTour(scope, probe = '[data-tour="row-edit"]') {
	const activator = `[data-tour-scope="${scope}"] [data-tour="row-menu"]`;

	async function openRowMenu() {
		await afterPendingClose();

		if (isVisible(probe)) {
			return;
		}

		const element = document.querySelector(activator);

		if (!element) {
			return;
		}

		element.click();
		await waitFor(probe, true);
	}

	async function closeMenus() {
		await afterPendingClose();

		// l'attivatore fa da interruttore: il secondo click richiude
		if (isVisible(probe)) {
			const element = document.querySelector(activator);

			if (element) {
				element.click();
			}

			await waitFor(probe, false);
		}
	}

	return { openRowMenu, closeMenus, probe };
}
